import { BodyPhotoAuthorRole, BodyPhotoImage, MemberBodyPhoto } from './types';

const isAuthorRole = (value: unknown): value is BodyPhotoAuthorRole => value === 'MEMBER' || value === 'COACH';

export const normalizeBodyPhoto = (value: any): MemberBodyPhoto => {
    const images: BodyPhotoImage[] = Array.isArray(value?.images)
        ? value.images
              .filter((image: any) => image?.imageId && (image?.url || image?.thumbnailUrl))
              .map((image: any) => ({
                  imageId: String(image.imageId),
                  url: String(image.url || image.thumbnailUrl),
                  thumbnailUrl: String(image.thumbnailUrl || image.url),
                  mimeType: String(image.mimeType || 'image/jpeg'),
                  size: Number(image.size || 0),
                  ...(Number.isFinite(Number(image.width)) ? { width: Number(image.width) } : {}),
                  ...(Number.isFinite(Number(image.height)) ? { height: Number(image.height) } : {}),
              }))
        : [];

    const uploadedByRole = value?.createdByRole ?? value?.uploadedByRole;

    return {
        id: String(value?.id ?? value?._id ?? ''),
        memberId: String(value?.memberId ?? ''),
        capturedAt: String(value?.capturedAt ?? value?.recordDate ?? ''),
        recordDate: String(value?.recordDate ?? value?.capturedAt ?? ''),
        version: Number(value?.version ?? value?.__v ?? 0),
        images,
        note: typeof value?.note === 'string' && value.note.trim() ? value.note : undefined,
        sharedCoachIds: Array.isArray(value?.sharedCoachIds) ? value.sharedCoachIds.map(String) : [],
        uploadedByRole: isAuthorRole(uploadedByRole) ? uploadedByRole : 'MEMBER',
        uploadedById: String(value?.createdById ?? value?.uploadedById ?? ''),
        createdAt: String(value?.createdAt ?? ''),
        updatedAt: String(value?.updatedAt ?? ''),
    };
};
